module.exports = require("live/components/header/ui/admin/header");